import classname from 'classname';
import { Spinner } from 'components/icons';
import React from 'react';
import { globalStyles } from 'styles';

export default function Fetching({ height }) {
  return (
    <div
      style={{
        height: height || '60vh',
      }}
      className={classname(
        globalStyles.flex,
        globalStyles.alignItemsCenter,
        globalStyles.justifyContentCenter
      )}
      data-testid="spinner"
    >
      <Spinner style={{ fill: 'transparent', width: '50px' }} />
    </div>
  );
}
